/** @jsx jsx */

import {
  Fragment as _,
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  cloneElement,
} from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector, useDispatch } from 'react-redux';
//
// import Audio_Illustration from 'assets/Character A.png';
import Audio_Illustration from 'assets/Mid Rectangle.svg';
//Audio_Illustration.svg';
import { audioAcknowledgedAction } from 'actions/audioAcknowledgedAction';
import { State } from 'store/store';
import Modal from 'components/UI/Modal';
import EditableText from 'components/lib/EditableText';
import EditableBtn from 'components/lib/EditableBtn';
import Image from 'components/lib/Image';
import renderBlock from 'services/apiHelpers/renderBlock';
import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';

export const ModuleHasAudioMessage = ({ onClose }) => {
  const audioAcknowledged = useSelector((state: State) => {
    return state.audioAcknowledged;
  });

  const [, setAudioAcknowledged] = useState<boolean>(audioAcknowledged);

  const moduleHasAudioMessageBlock = useSelector((state: State) => {
    return Object.values(state.blocks).find(block => {
      return block?.type === 'ModuleHasAudioMessage';
    });
  });

  let renderedModuleHasAudioMessageBlock;
  if (moduleHasAudioMessageBlock) {
    renderedModuleHasAudioMessageBlock = renderBlock(
      moduleHasAudioMessageBlock,
      {
        Image,

        Text: EditableText,
        EditableButton: EditableBtn,
      }
    );
  }

  const [img, txt, okBtn] =
    renderedModuleHasAudioMessageBlock?.props?.children || [];

  const hasTextContent = txt?.props?.content ? 'true' : 'false';

  const dispatch = useDispatch();

  useEffect(() => {
    if (hasTextContent === 'false') {
      requestAnimationFrame(() => {
        setBlockProps(getBlockById(txt.props.id), {
          content:
            '<div class="chameleon-text-align-center" data-type="textAlignCenter"><h2 data-type="heading-two"><p data-type="paragraph"><span style="font-size:1.75rem" data-type="fontSize"><strong data-type="bold">This module has audio</strong></span></p></h2></div><div class="chameleon-text-align-center" data-type="textAlignCenter"><h3 data-type="heading-three"><p data-type="paragraph"><span style="font-size:1.125rem" data-type="fontSize">Click Ok to continue</span></p></h3></div>',
        });
      });
    }
  }, []);

  // window.dev() ||
  if (audioAcknowledged) {
    return null;
  }

  return (
    <Modal
      key={hasTextContent}
      onClose={() => {
        // dispatch(audioAcknowledgedAction(true));
        onClose();
      }}
    >
      <div
        css={css({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '100px 0',
        })}
      >
        <div>
          {img ? (
            <div
              css={css({
                width: '100%',
                minWidth: 290,
                maxWidth: 540,
                margin: '0 0 30px 0',
              })}
            >
              {cloneElement(img, {
                placeholder: Audio_Illustration,
              })}
            </div>
          ) : (
            <img
              src={Audio_Illustration}
              css={css({
                width: '100%',
                minWidth: 290,
                maxWidth: 540,
                margin: '0 0 30px 0',
              })}
            />
          )}
        </div>

        {txt ? (
          txt
        ) : (
          <span className="chameleon-text">
            <h2
              css={css({
                margin: '0 0 10px 0',
                padding: '0 10px',
                fontWeight: 700,
                fontSize: 28,
                textAlign: 'center',
              })}
            >
              This module has audio
            </h2>
            <h3
              css={css({
                // margin: '0 0 10px 0',
                fontWeight: 400,
                fontSize: 18,
                textAlign: 'center',
              })}
            >
              Click OK to continue
            </h3>
          </span>
        )}

        {okBtn ? (
          <div
            css={css({
              margin: '20px 0 0 0',
            })}
          >
            {cloneElement(okBtn, {
              onClick() {
                onClose();
              },
            })}
          </div>
        ) : (
          <button
            className="module-has-audio-message-button"
            css={css({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: 'none',
              outline: 'none',
              width: 197,
              height: 46,
              margin: '20px 0 0 0',
              padding: 20,
              borderRadius: '9999px',
              background: '#060709',
              fontSize: 14,
              color: '#fff',
              cursor: 'pointer',

              transition: 'opacity 0.2s',

              ':hover': {
                opacity: 0.8,
              },

              boxShadow:
                '-16px -16px 27px rgba(255, 255, 255, 0.5), 16px 16px 27px rgba(37, 59, 176, 0.14393)',

              ':focus': {
                boxShadow: '0 0 0 2px #fff, 0 0 0 3px #060709 !important',
              },
            })}
            onClick={() => {
              onClose();
            }}
          >
            Ok
          </button>
        )}
      </div>
    </Modal>
  );
};
